import {createRouter, createWebHistory} from 'vue-router'
import {brandConfigMap} from "@/brand";
import {userAuthenticate} from "@/functions/userAuthenticate";

const routes = [
    {
        path: '/',
        redirect: getBaseRoute(),
    },
    {
        path: '/questions',
        name: 'QuestionScreen',
        component: () => import("@/views/QuestionScreen.vue"),
    },
    {
        path: '/match-found',
        name: 'MatchFound',
        component: () => import("@/views/MatchFound.vue"),
    },
]

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior() {
        window.scrollTo(0, 0);
    }
})

function getBaseRoute() {
    const domain = window.origin;
    const brandConfig = brandConfigMap.get(domain) ? brandConfigMap.get(domain) : brandConfigMap.get('default');
    return brandConfig.baseRoute;
}

router.beforeEach(async (to, from, next) => {
    await userAuthenticate(to, from, next);
})

export default router
